import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { materialSymbols } from '../../../shared/constants/material-symbols';

@Component({
    selector: 'app-update-scroller',
    templateUrl: './update-scroller.component.html',
    styleUrl: './update-scroller.component.scss',
    standalone: false
})
export class UpdateScrollerComponent {
  @Input() title: string = '';
  @Input() updateCount: number = 0;

  @ViewChild('cardsContainer') cardsContainer!: ElementRef;

  arrowForwardIos = materialSymbols.arrowForwardIos;
  arrowBackIos = materialSymbols.arrowBackIos;

  displayBackArrow: boolean = false;
  displayForwardArrow: boolean = false;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    const el = this.cardsContainer.nativeElement;
    this.displayForwardArrow = (el.scrollWidth > el.clientWidth);
    this.cdr.detectChanges();
  }

  onScroll() {

    const el = this.cardsContainer.nativeElement;
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;

    if (atEnd)
      this.displayForwardArrow = false;
    else
      this.displayForwardArrow = true;


    if (el.scrollLeft == 0)
      this.displayBackArrow = false;
    else
      this.displayBackArrow = true;

  }

  onForward() {
    this.displayBackArrow = true;
    const el = this.cardsContainer.nativeElement;
    el.scrollBy({ left: 400, behavior: 'smooth' });

    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;

    if (atEnd) {
      this.displayForwardArrow = false;
    }
  }

  onBackward() {
    this.displayForwardArrow = true;
    const el = this.cardsContainer.nativeElement;
    el.scrollBy({ left: -400, behavior: 'smooth' });

    if (el.scrollLeft == 0) {
      this.displayBackArrow = false;
    }
  }

}
